module.exports = __webpack_public_path__ + "static/pinkfloral6-a622301c89ba63c6c4f2702d28360279.png";